import createFacture from "./createFacture";

export default {
  namespaced: true,
  modules: {
    createFacture,
  },
};
